module.exports = __webpack_public_path__ + "img/Farm B.76def3bd.png";